module.exports = __webpack_public_path__ + "static/media/COS_EUCERIN_SOLAIRE.ed08af62.png";